import { render } from "./AssignAdditionalOption.vue?vue&type=template&id=0d5b3904&scoped=true"
import script from "./AssignAdditionalOption.vue?vue&type=script&lang=js"
export * from "./AssignAdditionalOption.vue?vue&type=script&lang=js"

import "./AssignAdditionalOption.vue?vue&type=style&index=0&id=0d5b3904&scoped=true&lang=css"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5b3904"]])

export default __exports__